import $ from 'jquery'
import store_parametre from "@/store/mods/clinique/parametres"
import RecapMonthlyConsuption from "@/components/view-article/recap-monthly-consumption"
import DateFilter from '@/components/date-filter';

export default {
    name: 'view-article',
    components: {
        RecapMonthlyConsuption, DateFilter
    },
    props: [],

    data() {
        return {
            repartition_fields: ['nom','quantite' ],
            entres_fields: ['stock','fournisseur', 'initial', 'nombre', 'date_peremption', 'date' ],
            sorties_fields: [
                'date', 'stock','motif', 'initial', { key: 'entree', label: 'Entrée' }, 
                { key: 'sortie', label: 'Sortie' }, { key: 'date_peremption', label: 'Date Péremption' }
            ],
            filter: "",
            perPage: 20,
            currentPage: 1,
            v: 0,

            save_loading: false,
			btn_disable: false,
			is_loading: false,
            liste_mvt_empty: false,
            sortie_per_page: 20,
            current_sortie_page: 1,
			
            base_assur_loading: true,
            base_is_empty: false,

            code_prod_fields: ['assurance', {key: 'code_prod_assurance', label: 'Code produit'}],
            code_prod_filter: "",
            code_prod_empty: false,
            code_prod_loading: true,
            liste_code_prod: [],

            page_title: '',
            type_article: '',
            liste_mouvement_stock: [],

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',
            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,

            tot_entree: 0,
            tot_sortie: 0
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }

        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                article_id: this.$route.params.id
            }
            this.current_date_filter = data
            this.getArticle(data)
            this.is_month = true
        },
    },

    computed: {
        article() {
            return this.$store.getters['article']
        },

        len_liste_sorties() {
            return this.article.sorties.length
        }
    },

    mounted() {
        this.type_article = this.$route.params.article
        if (this.type_article == 'medicaments') {
            this.page_title = 'Médicaments'
        } else if (this.type_article == 'consommables') {
            this.page_title = 'Consommables'
        }

        const data = {
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
            article_id: this.$route.params.id
        }
        this.current_date_filter = data
        this.getArticle(data)
        this.selectCodeProduit()
    },

    methods: {
        getArticle(data) {
            this.is_loading = true
            this.liste_mouvement_stock = []
            this.tot_entree = 0
            this.tot_sortie = 0

            this.$store.dispatch("getArticle", data).then(() => {
                // Merge this.article.sorties and this.article.entres to this.liste_mouvement_stock
                this.liste_mouvement_stock = this.article.sorties.concat(this.article.entres)

                // Reoorder the list by date
                this.liste_mouvement_stock.sort((a, b) => {
                    return new Date(b.created_at) - new Date(a.created_at)
                })

                if (this.liste_mouvement_stock.length > 0) {
                    this.liste_mvt_empty = false

                    this.liste_mouvement_stock.forEach(mvt => {
                        if (mvt.data_type == 'entree') {
                            this.tot_entree += mvt.nombre
                        } else if (mvt.data_type == 'sortie') {
                            this.tot_sortie += mvt.nombre
                        }
                    });
                } else {
                    this.liste_mvt_empty = true
                }

                this.is_loading = false
            })
        },

        first(str) {
            if (str ==null) {
                return 'M'
            } else {
                return str.charAt(0)
            }
        },


         /**
         * Open option dropdown
         */
        async openOption(v) {

            if(v == 0) {
                v = 1;
            } else {
                v = 0;
            }

            if (this.v == 0) {
                $('.option-box').fadeIn();
                $('#option-box').removeClass('animate-fadeOutRight');
                $('#option-box').addClass('animate-fadeInRight');
            } else {
                $('#option-box').removeClass('animate-fadeInRight');
                $('#option-box').addClass('animate-fadeOutRight');
                $('.option-box').fadeOut();
            }
            this.v = v;
        }, 

        async closeDropOption() {
            $('#option-box').removeClass('animate-fadeInRight');
            $('#option-box').addClass('animate-fadeOutRight');
            $('.option-box').fadeOut();

            this.v = 0;
        },

        clearError() {
            for (let i = 1; i <= 1; i++) {
                $('.msg-err-'+i).fadeOut(500)
            }
		},

        successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 6000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        selectCodeProduit() {
            this.code_prod_loading = true
            let type_prestation = ''
            if (this.type_article == 'medicaments') {
                type_prestation = 'medicament'
            } else {
                type_prestation = 'consommable'
            }
            const data = {
                type_prestation: type_prestation,
                prestation_id: this.$route.params.id
            }
            store_parametre.getCodeProduitAssurance(data).then((response) => {
                this.liste_code_prod = response
                if (response.length > 0) {
                    this.code_prod_empty = false
                } else {
                    this.code_prod_empty = true
                }

                this.code_prod_loading = false
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                article_id: this.$route.params.id
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.is_month = false
            this.getArticle(data)
        },
    }
}